import { render, staticRenderFns } from "./teamStatsDetail.vue?vue&type=template&id=7226cefc&scoped=true&"
import script from "./teamStatsDetail.vue?vue&type=script&lang=js&"
export * from "./teamStatsDetail.vue?vue&type=script&lang=js&"
import style0 from "./teamStatsDetail.vue?vue&type=style&index=0&id=7226cefc&scoped=true&lang=css&"
import style1 from "./teamStatsDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7226cefc",
  null
  
)

export default component.exports